/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CoreModule
 */

/**
 * @description
 *
 *      Comparator for natural sorting.
 *      A negative number if the reference string occurs before the compare string;
 *      positive if the reference string occurs after the compare string;
 *      0 if they are equivalent.
 */
export function naturalSort(a: string | number = '', b: string | number = ''): number {
    return `${a}`.localeCompare(`${b}`, undefined, { numeric: true });
}

